import { AnimatePresence } from 'framer-motion';
import { useMemo } from 'react';
import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { isWhiteColor } from '@/features/styles/lib/colors';
import { useStyles } from '../../hooks/useStyles';
import { getHsl } from '../../lib/styles';
import { getStars, type Star as StarType } from './lib';
import { Star } from './Star';

type StarsProps = {
  starsOverride?: StarType[];
};

export const Stars = ({ starsOverride }: StarsProps) => {
  const { experience } = usePageExperienceContext();
  const { sparkleConfig } = useStyles();

  const stars = useMemo(() => {
    if (starsOverride) {
      return starsOverride;
    }

    if (!experience) return [];

    return getStars({
      seed: experience.id,
      totalCount: sparkleConfig.stars.totalCount,
      numberOfClusters: sparkleConfig.stars.clusterCount,
    });
  }, [experience, sparkleConfig, starsOverride]);

  return (
    <AnimatePresence>
      {stars.map((star, index) => (
        <Star
          key={index}
          fillColor={
            experience && isWhiteColor(getHsl(experience)) ? '#E9E9E9' : '#fff'
          }
          {...star}
        />
      ))}
    </AnimatePresence>
  );
};
